"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
var examples_1 = require("@shared/examples");
var EXAMPLE_SRC = 'components/icon/examples/index.ts';
var iconNames = Object.keys(_1.Icons).slice(1);
var IconExample = /** @class */ (function () {
    function IconExample() {
        this.interactive = false;
        this.iconName = _1.Icons.SETTINGS;
    }
    IconExample.prototype.view = function () {
        return (0, mithril_1.default)(examples_1.Example, { options: this.renderOptions(), src: EXAMPLE_SRC }, [
            (0, mithril_1.default)(_1.Icon, {
                intent: this.intent,
                name: this.iconName,
                onclick: this.interactive ? function () { return null; } : undefined,
                size: 'xl'
            })
        ]);
    };
    IconExample.prototype.renderOptions = function () {
        var _this = this;
        return [
            (0, mithril_1.default)('h5', 'Intent'),
            (0, mithril_1.default)(examples_1.IntentSelect, { onSelect: function (intent) { return _this.intent = intent; } }),
            (0, mithril_1.default)('h5', 'Icon name'),
            (0, mithril_1.default)(_1.SelectList, {
                closeOnSelect: false,
                items: iconNames,
                itemRender: function (iconName) { return (0, mithril_1.default)(_1.ListItem, {
                    contentLeft: (0, mithril_1.default)(_1.Icon, { name: _1.Icons[iconName] }),
                    label: iconName,
                    selected: _this.iconName === _1.Icons[iconName]
                }); },
                itemPredicate: function (query, item) {
                    return item.toLowerCase().includes(query.toLowerCase());
                },
                trigger: (0, mithril_1.default)(_1.Button, {
                    align: 'left',
                    compact: true,
                    iconRight: _1.Icons.CHEVRON_DOWN,
                    label: this.iconName,
                    size: 'xs',
                    style: 'margin-bottom: 10px',
                    fluid: true
                }),
                onSelect: function (iconName) { return _this.iconName = _1.Icons[iconName]; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.interactive,
                label: 'Interactive',
                onchange: function () { return _this.interactive = !_this.interactive; }
            })
        ];
    };
    return IconExample;
}());
exports.IconExample = IconExample;
